export function TypingIndicator() {
  return (
    <div className="flex justify-start">
      <div className="bg-[#1A1A1A] border border-gray-800 rounded-2xl px-4 py-3 flex items-center gap-1">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce"
            style={{ animationDelay: `${i * 150}ms`, animationDuration: "0.6s" }}
          />
        ))}
      </div>
    </div>
  );
}
